import { Injectable } from '@angular/core';

import { TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';
import { BetslipListType } from '@frontend/sports/types/models/my-bets';

import { ReBetTracking, TrackReBet } from './re-bet.models';

@Injectable()
export class ReBetTrackingService {
    constructor(private trackingService: TrackingService) {}

    trackCtaShown(selectionsNumber: number, listType: BetslipListType): void {
        const trackingData: TrackReBet = {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: ReBetTracking.MyAccount,
            [trackingConstants.COMPONENT_LABEL_EVENT]: ReBetTracking.MyBets,
            [trackingConstants.COMPONENT_ACTION_EVENT]: ReBetTracking.Load,
            [trackingConstants.COMPONENT_POSITION_EVENT]: selectionsNumber.toString(),
            [trackingConstants.COMPONENT_LOCATION_EVENT]: this.getLocationEvent(listType),
            [trackingConstants.COMPONENT_EVENT_DETAILS]: ReBetTracking.ReBetButton,
            [trackingConstants.COMPONENT_URL_CLICKED]: ReBetTracking.NotApplicable,
        };
        this.trackingService.track('contentView', trackingData, { timeout: 0 });
    }

    trackCtaClicked(selectionsNumber: number, listType: BetslipListType): void {
        const trackingData: TrackReBet = {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: ReBetTracking.MyAccount,
            [trackingConstants.COMPONENT_LABEL_EVENT]: ReBetTracking.MyBets,
            [trackingConstants.COMPONENT_ACTION_EVENT]: ReBetTracking.Click,
            [trackingConstants.COMPONENT_POSITION_EVENT]: selectionsNumber.toString(),
            [trackingConstants.COMPONENT_LOCATION_EVENT]: this.getLocationEvent(listType),
            [trackingConstants.COMPONENT_EVENT_DETAILS]: ReBetTracking.ReBetButton,
            [trackingConstants.COMPONENT_URL_CLICKED]: ReBetTracking.NotApplicable,
        };
        this.trackingService.track('Event.Tracking', trackingData, { timeout: 0 });
    }

    private getLocationEvent(listType: BetslipListType): string {
        switch (listType) {
            case BetslipListType.Live:
                return ReBetTracking.LiveTab;
            case BetslipListType.Open:
                return ReBetTracking.OpenTab;
            case BetslipListType.Settled:
                return ReBetTracking.SettledTab;
            default:
                return '';
        }
    }
}
